import * as React from "react";

const ChatGPTIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 48 48"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M18.38 27.94v-14.4l11.19-6.46c6.2-3.58 17.3 5.25 12.64 13.33"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="m18.38 20.94 12.47-7.2 11.19 6.46c6.2 3.58 4.1 17.61-5.23 17.61"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="m24.44 17.44 12.47 7.2v12.93c0 7.16-13.2 12.36-17.86 4.28"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M30.5 21.2v14.14L19.31 41.8c-6.2 3.58-17.3-5.25-12.64-13.33"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="m30.5 27.94-12.47 7.2-11.19-6.46c-6.21-3.59-4.11-17.61 5.22-17.61"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      d="m24.44 31.44-12.47-7.2V11.31c0-7.16 13.2-12.36 17.86-4.28"
    ></path>
  </svg>
);

export default ChatGPTIcon;
